import { render, staticRenderFns } from "./makeSurePas.vue?vue&type=template&id=5400857e&scoped=true"
import script from "./makeSurePas.vue?vue&type=script&lang=js"
export * from "./makeSurePas.vue?vue&type=script&lang=js"
import style0 from "./makeSurePas.vue?vue&type=style&index=0&id=5400857e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5400857e",
  null
  
)

export default component.exports